import {useUpmPlantTimezone} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {MaterialQualityParametersContainer} from '@widgets/kpis'

import {useOptimizationSpecialistTimeRange} from '../hooks'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const OptimizationSpecialistMaterialQualityKpisContainer = ({
  plantId,
  cardBoxSx,
  placeholderWrapperSx
}: Props) => {
  const timezone = useUpmPlantTimezone(plantId)
  const {start, end} = useOptimizationSpecialistTimeRange(plantId)
  const from = start?.toISOString()
  const to = end?.toISOString()

  return (
    <MaterialQualityParametersContainer
      plantId={plantId}
      cardBoxSx={cardBoxSx}
      from={from}
      to={to}
      placeholderWrapperSx={placeholderWrapperSx}
      timezone={timezone}
      isVerticalLayout={false}
    />
  )
}
